import React from 'react'
import css from './DynamicText.module.css'

export const DynamicText = React.memo(({children, customClasses, ...otherProps}) => {
    return(
        <div className={`absolute ${css.dynamic_text} ${customClasses}`} {...otherProps} 
            dangerouslySetInnerHTML={{ __html: children}}
        />
    )
})